import styled from 'styled-components';
import { VehicleType } from '~/shared';

const StyledContainer = styled.div`
	display: flex;
	width: 400px;
	height: 10px;
	border-radius: 6px;
	background-color: rgba(255, 255, 255, 0.1);
	overflow: hidden;
`;

const StyledProgressWrapper = styled.div`
	position: relative;
	height: 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
`;

const StyledProgress = styled.div`
	position: absolute;
	top: 4px;
	left: 4px;
	right: 4px;
	bottom: 4px;
	display: flex;
	border-radius: 3px;
	overflow: hidden;
`;

const StyledProgressItem = styled.div`
	height: 10px;
	&.${VehicleType.CAR} {
		background-color: #fabe2c;
	}

	&.${VehicleType.BIKE} {
		background-color: #68dcb2;
	}

	&.boat {
		background-color: #a968dc;
	}
`;

export {
	StyledContainer,
	StyledProgress,
	StyledProgressItem,
	StyledProgressWrapper,
};
